import React, { Component } from "react";
import StepperPage from "./StepperPage";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

const styles = (theme) => ({
  checkmark: {
    margin: "0 auto",
    width: 150,
    height: 150,
    borderRadius: "50%",
    display: "block",
    strokeWidth: 2,
    stroke: "#fff",
    strokeMiterlimit: 10,
    boxShadow: "inset 0px 0px 0px #7ac142",
    animation:
      "$fill .4s ease-in-out .4s forwards, $scale .3s ease-in-out .9s both",
  },
  checkmarkCircle: {
    strokeDasharray: 166,
    strokeDashoffset: 166,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    stroke: "#7ac142",
    fill: "none",
    animation: "$stroke .6s cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards",
  },
  checkmarkCheck: {
    transformOrigin: "50% 50%",
    strokeDasharray: 48,
    strokeDashoffset: 48,
    animation:
      "$stroke .3s cubic-bezier(0.650, 0.000, 0.450, 1.000) .8s forwards",
  },
  "@keyframes fill": {
    "100%": {
      boxShadow: "inset 0px 0px 0px 100px #7ac142",
    },
  },
  "@keyframes scale": {
    "0%, 100%": {
      transform: "none",
    },
    "50%": {
      transform: "scale3d(1.1, 1.1, 1)",
    },
  },
  "@keyframes stroke": {
    "100%": {
      strokeDashoffset: 0,
    },
  },
});

export class DonePage extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ textAlign: "center" }}>
            <svg
              className={classes.checkmark}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className={classes.checkmarkCircle}
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className={classes.checkmarkCheck}
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
            <Typography style={{ marginTop: 30 }}>
              <>
                {this.props.editKs &&
                Object.keys(this.props.editKs).length > 0 ? (
                  <Trans
                    i18nKey="create_ks_edited"
                    values={{ description: this.props.description }}
                  />
                ) : (
                  <Trans
                    i18nKey="create_ks_added"
                    values={{ description: this.props.description }}
                  />
                )}
              </>
            </Typography>
            {this.props.wasReindex ? (
              <>
                {this.props.editKs &&
                Object.keys(this.props.editKs).length > 0 ? (
                  <Typography style={{ marginTop: 30 }}>
                    <Trans i18nKey="create_ks_edited_index_in_progress" />
                  </Typography>
                ) : (
                  <Typography style={{ marginTop: 30 }}>
                    <Trans i18nKey="create_ks_added_index_in_progress" />
                  </Typography>
                )}
              </>
            ) : (
              <>
                {this.props.editKs &&
                Object.keys(this.props.editKs).length > 0 ? (
                  <Typography style={{ marginTop: 30 }}>
                    <Trans i18nKey="create_ks_edited_not_indexed" />
                  </Typography>
                ) : (
                  <Typography style={{ marginTop: 30 }}>
                    <Trans i18nKey="create_ks_added_not_indexed" />
                  </Typography>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default StepperPage(withStyles(styles)(DonePage));
